import { connect } from 'react-redux'

import { toggleSidebarCollapsed } from 'actions/ui/app'
import {
    selectHasNoIntegrations,
    selectUserOrganizationFeaturePermissions,
} from 'selectors/auth'
import { selectCurrentOrganization } from 'selectors/orgs'
import { selectDomainValue, selectIsSidebarCollapsed } from 'selectors/ui'
import { RootReduxState } from 'types'

import AppLayout, { AppLayoutProps } from './AppLayout'

const mapStateToProps = (
    state: RootReduxState
): Pick<
    AppLayoutProps,
    | 'hasNoIntegrations'
    | 'currentOrganization'
    | 'featurePermissions'
    | 'isSidebarCollapsed'
    | 'mounting'
> => ({
    hasNoIntegrations: selectHasNoIntegrations(state),
    currentOrganization: selectCurrentOrganization(state),
    featurePermissions: selectUserOrganizationFeaturePermissions(state),
    isSidebarCollapsed: selectIsSidebarCollapsed(state),
    mounting: selectDomainValue(state, ['app', 'mounting']),
})

const mapDispatchToProps: Pick<AppLayoutProps, 'toggleSidebarCollapsed'> = {
    toggleSidebarCollapsed,
}

export default connect(mapStateToProps, mapDispatchToProps)(AppLayout)
